module.exports = __webpack_public_path__ + "static/media/ban1.27f8813f.png";